import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import FacebookLogin from "react-facebook-login";
import GoogleLogin from "react-google-login";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Phone from "./../utils/Phone";
import Direccion from "./../utils/Direccion";
import { parseJwt, validateEmail } from "./../utils/utils";

const { Select2, Date, DateTime, Text } = Inputs;

function Registro({ history, match }) {
  const dispatch = useDispatch();
  const modelRegistro = useSelector((state) => state.registro);
  const modelOrganizacion = useSelector((state) => state.organizacionById);
  const modelInvitacion = useSelector((state) => state.getInvitacion);
  const modelCrearInvitacion = useSelector((state) => state.crearAutoInvitacion);
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [nombre, setNombre] = useState(null);
  const [apellido, setApellido] = useState(null);
  const [document, setDocument] = useState("");
  const [rol, setRol] = useState("superadmin");
  const [direccion, setDireccion] = useState("");
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [tel, setTel] = useState("+595");
  const [invitacionMsg, setInvitacionMsg] = useState(null);
  const [tipoInvitacion, setTipoInvitacion] = useState(null);
  const [rolInvitacion, setRolInvitacion] = useState(null);

  const responseFacebook = (response) => {

    let data = {
      socialAccountID: response.userID,
      site: "facebook",
      socialName: response.name,
      organizacionID: "Particular",
      invitacionToken: match?.params?.token ? match.params.token : null,
    };

    dispatch(controller.registroThunk(data));
  };

  const responseGoogle = (response) => {

    let data = {
      socialAccountID: response.profileObj.googleId,
      site: "google",
      socialName: response.profileObj.name,
      organizacionID: "Particular",
      invitacionToken: match?.params?.token ? match.params.token : null,
    };
    dispatch(controller.registroThunk(data));
  };

  useEffect(() => {
    const data = modelOrganizacion?.data?.data?.data;
    const error = modelOrganizacion?.error?.response?.data?.mensaje;
    if (error) {
      alert(error);
      dispatch(controller.duckOrganizacion.actions.clear());

      history.push("/logout");
    }
    if (data) {
      const msg =
        "Usted ha sido invitado por " +
        data.nombre +
        " a formar parte como " +
        rolInvitacion;
      setInvitacionMsg(msg);
      dispatch(controller.duckOrganizacion.actions.clear());
    }
  }, [modelOrganizacion]);

  useEffect(() => {
    const data = modelRegistro?.data?.data;
    const error = modelRegistro?.error?.response?.data?.mensaje;



    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      alert("Registro exitoso");
      history.push("/login");
      dispatch(controller.duck.actions.clear());
    }
  }, [modelRegistro]);

  useEffect(() => {

    // Resultado de consultar invitación

    const data = modelInvitacion?.data?.data;
    const error = modelInvitacion?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckInvitacion.actions.clear());

      history.push("/logout");
    }

    if (data) {



      setRolInvitacion(data.data.rol);
      setTipoInvitacion(data.data.tipo);

      dispatch(controller.duckInvitacion.actions.clear());

      if (data.data.tipo === 'autoinvitacion') {
        let autoInvitacionSignUpParams = {
          invitacionToken: match.params.token,
        };
        dispatch(controller.registroThunk(autoInvitacionSignUpParams));
      } else {

        dispatch(controller.organizacionByIdThunk(data.data.organizacionID));
      }
    }
  }, [modelInvitacion]);

  useEffect(() => {

    // Resultado de crear invitación



    const data = modelCrearInvitacion?.data?.data;
    const code = modelCrearInvitacion?.data?.data?.code;
    const error = modelCrearInvitacion?.error?.response?.data?.mensaje;

    if (error) {

      alert(error);
      dispatch(controller.duckCrearAutoInvitacion.actions.clear());
    }

    if (data?.data?._id) {

      alert('Te enviamos un mensaje para que puedas confirmar tu registro!');
      dispatch(controller.duckCrearAutoInvitacion.actions.clear());
      history.push(`/confirmacion/${data?.data?._id}`);
    }
  }, [modelCrearInvitacion]);

  useEffect(() => {
    // componentDidMount
    if (match.params.token) {
      dispatch(controller.getInvitacionBytokenthunk(match.params.token));
    }
  }, []);

  function registrar() {

    let data = {
      username,
      password,
      document,
      nombre: nombre,
      phoneNumber: tel,
      address: {
        direccion: direccion,
        lat: lat,
        lng: lng,
      },
      rol: "vendedor",
      organizacionID: "Particular",
      invitacionToken: match?.params?.token ? match.params.token : null,
      origen: "agendia-admin",
    };

    dispatch(controller.registroThunk(data));
  }

  const crearAutoInvitacion = () => {

    let data = {
      email: username,
      password,
      nombre: nombre,
      telefono: tel,
      address: {
        direccion: direccion,
        lat: lat,
        lng: lng,
      },
      invitacionToken: match?.params?.token ? match.params.token : null,
    };
    dispatch(controller.crearAutoInvitacionThunk(data));
  };

  const guardarDatos = () => {



    if (!validateEmail(username)) {
      alert("Por favor proporcione un email con el formato correcto");
      return;
    }

    if (!username || !password || !nombre || !tel) {
      return alert("Por favor complete todos los campos");
    }

    // Si hay rolInvitacion es porque
    // este registro se está haciendo
    // al entrar al link de una invitación.

    if (rolInvitacion) {
      registrar();
    } else {
      crearAutoInvitacion();
    }
  };

  if (
    match?.params?.token
    && !tipoInvitacion
  ) {
    return (<p>Cargando...</p>);
  } else if (
    match?.params?.token
    && tipoInvitacion === 'autoinvitacion'
  ) {
    return (<p>Procesando...</p>);
  }

  return (
    <Content title="Registro" browserTitle="Registro" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box title="Crear cuenta">
            {invitacionMsg ? (
              <h4 style={{ textAlign: "center" }}>{invitacionMsg}</h4>
            ) : null}

            {/* <Row style={{ marginBottom: 20 }}>
              <Col md="6">
                <GoogleLogin
                  clientId="369617600572-7grqfljnkuck9d2gv5m6694tc2d12e72.apps.googleusercontent.com"
                  buttonText="Ingresar con GMAIL"
                  onSuccess={responseGoogle}
                  onFailure={responseGoogle}
                  cookiePolicy={"single_host_origin"}
                />
              </Col>
              <Col md="6">
                <FacebookLogin
                  appId="131982598803840"
                  fields="name,email, first_name, last_name"
                  scope="public_profile,user_friends"
                  callback={responseFacebook}
                  icon="fa-facebook"
                  size="small"
                  textButton="Ingresar con FB"
                  autoLoad={false}
                />
              </Col>
            </Row> */}

            <Text
              labelPosition="above"
              size="sm"
              label="Nombre completo"
              onChange={(evt) => setNombre(evt.target.value)}
            />
            {/* <Text
              labelPosition="above"
              size="sm"
              label="Documento de identidad"
              onChange={(evt) => setDocument(evt.target.value)}
            /> */}
            <Text
              labelPosition="above"
              size="sm"
              label="Correo electrónico"
              onChange={(evt) => setUsername(evt.target.value)}
            />

            <Text
              inputType="password"
              labelPosition="above"
              size="sm"
              label="Password"
              onChange={(evt) => setPassword(evt.target.value)}
            />

            <Phone value={tel} setValue={setTel} international={false} />

            {/* <Direccion
              direccion={direccion}
              setDireccion={setDireccion}
              setLat={setLat}
              setLng={setLng}
            /> */}

            <Button
              type="primary"
              text="Registrarse"
              pullRight={true}
              onClick={() => guardarDatos()}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default Registro;
